// extracted by mini-css-extract-plugin
module.exports = {"completed":"styles-module__completed___sVj1c"};